import type { Dictionary } from './ru'

export const uz: Dictionary = {
  'common.currency': "so'm",
  'common.amount': "{amount} so'm",
  'common.toCatalog': 'Katalogga qaytish',
  'common.support': "Qo'llab-quvvatlashga yozish",
  'common.retry': 'Qayta urinish',
  'common.cancel': 'Bekor qilish',
  'purchase.step': '{step}/3-qadam · {name}',
  'purchase.stepAmount': 'Nominal',
  'purchase.stepGreeting': 'Qabul qiluvchi va tabrik',
  'purchase.stepPay': "To'lov",
  'howTo.title': "Sovg'ani qanday yuborish",
  'howTo.sub': "Storis yo'riqnoma · 6 qadam",
  'howTo.tipSub': "Storisda 6 qadamda ko'rsatamiz",
  'howTo.tipHide': 'Maslahatni yashirish',

  'catalog.search': 'Hamkorni qidirish',
  'catalog.searchClear': 'Qidiruvni tozalash',
  'catalog.allCategories': 'Barchasi',
  'catalog.categories': 'Toifalar',
  'catalog.priceFrom': '{amount} dan',
  'catalog.priceSingle': "{amount} so'm",
  'catalog.emptySearchTitle': 'Hech narsa topilmadi',
  'catalog.emptySearchText': "Boshqa nom yoki toifani sinab ko'ring.",
  'catalog.emptyCategoryTitle': "Bu toifada hozircha hamkorlar yo'q",
  'catalog.emptyCategoryText': 'Boshqa toifani tanlang yoki keyinroq qaytib keling.',
  'catalog.emptyTitle': "Hozircha hamkorlar yo'q",
  'catalog.emptyText': "Tez orada bu yerda sovg'alar paydo bo'ladi.",
  'catalog.resetFilters': "Barcha hamkorlarni ko'rsatish",
  'catalog.loadErrorTitle': "Hamkorlarni yuklab bo'lmadi",
  'catalog.loadErrorOffline': "Internet aloqasini tekshiring va qayta urinib ko'ring.",
  'catalog.loadErrorText': "Bir daqiqadan so'ng qayta urinib ko'ring.",
  'catalog.loadMoreError': "Davomini yuklab bo'lmadi",

  'category.food': 'Taomlar',
  'category.beauty': "Go'zallik",
  'category.sport': 'Sport',
  'category.clothing': 'Kiyim',
  'category.electronics': 'Elektronika',
  'category.entertainment': "Ko'ngilochar",
  'category.services': 'Xizmatlar',
  'category.kids': 'Bolalar uchun',

  'partner.pickAmount': 'Nominalni tanlang',
  'partner.amountTitle': 'Nominal',
  'partner.next': "Keyingisi · {amount} so'm",
  'partner.note': "Vaucher muddatsiz va to'lovdan so'ng darhol keladi — uni chatga o'zingiz yuborasiz.",
  'partner.where': 'Qayerda qabul qilinadi',
  'partner.unavailableTitle': "Sovg'alar vaqtincha mavjud emas",
  'partner.unavailableText': "Hozir bu hamkorni sovg'a qilib bo'lmaydi. Keyinroq qaytib keling yoki boshqasini tanlang.",
  'partner.notFoundTitle': 'Hamkor topilmadi',
  'partner.notFoundText': 'Havola eskirgan yoki hamkor endi biz bilan ishlamaydi.',

  'checkout.change': "O'zgartirish",
  'checkout.recipientName': 'Qabul qiluvchi ismi',
  'checkout.recipientPlaceholder': 'Masalan, Malika',
  'checkout.recipientNote': 'Sizning ismingiz Telegram profilidan avtomatik olinadi.',
  'checkout.message': 'Tabrik matni',
  'checkout.messagePlaceholder': "Bir-ikki iliq so'z — ularni qabul qiluvchi ko'radi",
  'checkout.messageHint': "Sovg'a ochilish animatsiyasidan keyin ko'rinadi.",
  'checkout.ideas': 'Tayyor tabriklar',
  'checkout.idea1': "Tug'ilgan kuning bilan!",
  'checkout.idea1Text': "Tug'ilgan kuning bilan! Bu yil quvonch va iliq uchrashuvlarga boy bo'lsin.",
  'checkout.idea1Named': "{name}, tug'ilgan kuning bilan! Bu yil quvonch va iliq uchrashuvlarga boy bo'lsin.",
  'checkout.idea2': 'Tabriklayman!',
  'checkout.idea2Text': "Tabriklayman! Bunga munosibsan — hammasi yaxshi bo'lsin.",
  'checkout.idea2Named': "{name}, tabriklayman! Bunga munosibsan — hammasi yaxshi bo'lsin.",
  'checkout.idea3': 'Rahmat senga',
  'checkout.idea3Text': 'Hamma narsa uchun rahmat — bu katta minnatdorchilikning kichik belgisi.',
  'checkout.idea3Named': '{name}, hamma narsa uchun rahmat — bu katta minnatdorchilikning kichik belgisi.',
  'checkout.idea4': 'Bayraming bilan!',
  'checkout.idea4Text': "Bayraming bilan! Iliqlik va tabassum ko'p bo'lsin.",
  'checkout.idea4Named': "{name}, bayraming bilan! Iliqlik va tabassum ko'p bo'lsin.",
  'checkout.idea5': 'Shunchaki',
  'checkout.idea5Text': 'Shunchaki — bugun seni xursand qilish uchun.',
  'checkout.idea5Named': '{name}, bu shunchaki — bugun seni xursand qilish uchun.',
  'checkout.presetReplace': 'Matningiz «{text}» bilan almashtirilsinmi?',
  'checkout.presetReplaceOk': 'Almashtirish',
  'checkout.note': "To'lov usulini keyingi qadamda tanlaysiz.",
  'checkout.toPay': "To'lovga o'tish",
  'checkout.pendingTitle': "Bu sovg'a to'lovni kutmoqda",
  'checkout.pendingText': "To'lov tizimidan hali tasdiq kelmadi.",
  'checkout.pendingAction': "To'lovni tekshirish",
  'checkout.paidTitle': "Bu sovg'a allaqachon to'langan",
  'checkout.paidText': "Qayta to'lash shart emas — uni chatga yuborish qoldi.",
  'checkout.paidAction': "Sovg'ani ochish",
  'checkout.unavailableTitle': "Sovg'a endi mavjud emas",
  'checkout.unavailableText': "Bu nominal hozir sotuvda yo'q. Katalogdan boshqa sovg'ani tanlang.",

  'pay.method': "To'lov usuli",
  'pay.methodClick': 'Click oynasida UZCARD yoki Humo kartasi',
  'pay.methodPayme': 'Karta yoki Payme balansi',
  'pay.methodFoot': "To'lov to'lov tizimining himoyalangan sahifasida o'tadi. Bank tasdiqlashi bilan ekran o'zi yangilanadi.",
  'pay.payAmount': "To'lash · {amount} so'm",
  'pay.opening': "To'lov tizimi ochilmoqda…",
  'pay.openingHint': 'Oynani yopmang, bir necha soniya oladi',
  'pay.retry': "Qayta to'lash",
  'pay.leaveConfirm': "To'lov hali davom etmoqda. Ekrandan chiqsangiz, u to'xtamaydi: bank tasdiqlagach, sovg'a yuborilishini kutadi.",
  'pay.leave': 'Chiqish',
  'pay.stay': 'Qolish',
  'pay.errorDailyCount': "Bugun {limit} ta sovg'a sotib oldingiz — bu kunlik chegara. Ertaga urinib ko'ring.",
  'pay.errorDailyAmount': "Bu sovg'a bilan bugungi xaridlar {limit} so'mdan oshadi — bu kunlik chegara. Kichikroq nominalni tanlang yoki ertaga urinib ko'ring.",
  'pay.errorProviderDown': "{provider} hozir javob bermayapti. Boshqa to'lov usulini tanlang.",
  'pay.errorInProgress': "{provider} orqali to'lov hali tugamadi. Boshqa usulda to'lashdan oldin uning natijasini kuting.",
  'pay.errorInProgressAction': "To'lovga qaytish",
  'pay.errorNetwork': "Aloqa yo'q. Internetni tekshiring va qayta urinib ko'ring.",
  'pay.errorUnknown': "To'lovni boshlab bo'lmadi. Qayta urinib ko'ring.",
  'pay.giftKind': "Sovg'a sertifikati",
  'pay.price': 'Narxi',
  'pay.total': "To'lovga",

  'payWait.title': "To'lov kutilmoqda",
  'payWait.text': "To'lov tizimi sahifasida to'lovni yakunlang — bank tasdiqlashi bilan ekran o'zi yangilanadi.",
  'payWait.checkingTitle': "To'lov tekshirilmoqda",
  'payWait.checkingText': "Bank hali tasdiq yubormadi. Odatda bu bir-ikki daqiqa oladi — ekran o'zi yangilanadi.",
  'payWait.stalledTitle': "To'lov hali tasdiqlanmadi",
  'payWait.stalledText': "Tasdiq kechikmoqda. Birozdan so'ng qayta tekshiring — to'lov yo'qolmaydi.",
  'payWait.checkAgain': 'Qayta tekshirish',
  'payWait.reopen': "To'lov sahifasini ochish",
  'payWait.timeLeft': 'Hisob yana {time} amal qiladi',
  'payWait.offline': "Aloqa yo'q — tarmoq paydo bo'lishi bilan tekshiramiz.",

  'paySuccess.title': "To'lov o'tdi",
  'paySuccess.text': "Sovg'a tayyor. «Sovg'ani yuborish» tugmasini bosing va qabul qiluvchi bilan chatni tanlang.",
  'paySuccess.send': "Sovg'ani yuborish",
  'paySuccess.recipient': 'Qabul qiluvchi',
  'paySuccess.order': 'Buyurtma raqami',
  'paySuccess.time': 'Vaqt',
  'paySuccess.sendFallback': "Qabul qiluvchi bilan chatni oching, {bot} deb yozing va sovg'ani tanlang.",
  'paySuccess.sendFallbackNoBot': "Qabul qiluvchi bilan chatni oching, botimiz nomini @ bilan yozing va sovg'ani tanlang.",
  'stories.step': '{step}/6-qadam',
  'stories.step1': 'Sertifikatni tanlang',
  'stories.step2': 'Summa va tabrikni kiriting',
  'stories.step3': "To'lang",
  'stories.step4': "«Sovg'ani yuborish» tugmasini bosing va chatni tanlang",
  'stories.step5': "Ro'yxatdan sovg'ani tanlang",
  'stories.step6': 'Yuboring',
  'stories.manualHint': "yoki chatda {bot} deb yozing va sovg'ani tanlang",
  'stories.manualHintNoBot': "yoki chatda botimiz nomini @ bilan yozing va sovg'ani tanlang",
  'stories.gotIt': 'Tushunarli',
  'stories.close': 'Yopish',
  'stories.prev': 'Oldingi qadam',
  'stories.next': 'Keyingi qadam',

  'payCancel.title': "To'lov bekor qilindi",
  'payCancel.text': "Pul yechilmadi. Sovg'a qoralamasi saqlandi — to'lovga qaytish mumkin.",

  'payFail.title': "To'lov o'tmadi",
  'payFail.notCharged': 'Pul yechilmadi.',
  'payFail.otherMethod': "Boshqa to'lov usuli",
  'payFail.insufficientFunds': "Bank operatsiyani rad etdi: kartada mablag' yetarli emas.",
  'payFail.cardBlocked': 'Bank operatsiyani rad etdi: karta bloklangan.',
  'payFail.cardExpired': 'Bank operatsiyani rad etdi: karta muddati tugagan.',
  'payFail.limitExceeded': 'Bank operatsiyani rad etdi: karta limiti oshib ketgan.',
  'payFail.declinedByBank': "Bank operatsiyani rad etdi va sababini ko'rsatmadi.",
  'payFail.cancelledByUser': "To'lov tizimi sahifasida to'lov bekor qilindi.",
  'payFail.timeout': "To'lov tizimida to'lov vaqti tugadi.",
  'payFail.providerError': "To'lov tizimi tomonida nosozlik yuz berdi.",
  'payFail.unknown': "To'lov tizimi to'lovni rad etdi va sababini ko'rsatmadi.",

  'payExpired.title': "To'lov vaqti tugadi",
  'payExpired.text': "Pul yechilmadi. Sovg'ani qaytadan rasmiylashtiring — tabrik saqlangan.",
  'payExpired.restart': 'Qaytadan rasmiylashtirish',

  'payResult.notFoundTitle': 'Buyurtma topilmadi',
  'payResult.notFoundText': 'Havola eskirgan yoki buyurtma boshqa hisobdan rasmiylashtirilgan.',

  'unwrap.from': "{name} dan sizga sovg'a",
  'unwrap.fromAnonymous': "Sizga anonim sovg'a",
  'unwrap.tapToOpen': 'Ochish uchun bosing',
  'unwrap.opening': "Sovg'a ochilmoqda…",
  'unwrap.failedOffline': "Internet aloqasi yo'q. Tekshirib ko'ring — aloqa tiklanishi bilan sovg'a ochiladi.",
  'unwrap.failed': "Sovg'ani ochib bo'lmadi. Bir daqiqadan so'ng qayta urinib ko'ring.",

  /* Экран 09 — сцена GiftBox и карточка-сюрприз. Карточка без ответа бэкенда — без партнёра и суммы. */
  'unwrap.open': "Sovg'ani ochish",
  'unwrap.what': 'Ichida nima bor ekan?',
  'unwrap.tease1': "Balki sevimli do'koningizga sertifikatdir?",
  'unwrap.tease2': "Yoki {name} dan iliq so'zlar?",
  'unwrap.tease2Anonymous': "Yoki iliq so'zlar?",
  'unwrap.tease3': "Oching va birinchi bo'lib biling!",
  'unwrap.reveal': 'Siz uchun sertifikat!',
  'unwrap.revealSub': "Hozir tabrikni ko'rsatamiz",
  'reveal.genericTitle': "Sovg'a",
  'reveal.genericAmount': 'Sertifikat',
  'reveal.genericUnit': 'siz uchun',

  'gift.takenTitle': "Voy! Sovg'a topilmadi",
  'gift.takenText': "Uni boshqa kishi ochgan yoki u endi mavjud emas. Uzatilgan sovg'alar ishlamaydi.",
  'gift.giveOwn': "O'zim sovg'a qilaman",
  'gift.notSentTitle': "Bu sovg'a hali topshirilmagan",
  'gift.notSentText': "Yuboruvchi uni hali chatga yubormagan yoki qaytarib olgan. Sovg'ani qayta yuborishini so'rang.",
  'gift.goneTitle': "Sovg'a endi mavjud emas",
  'gift.goneText': "Sovg'a bekor qilindi, vaucher endi amal qilmaydi. Agar bu xato bo'lsa, qo'llab-quvvatlashga yozing.",
  'gift.blockedTitle': "Sovg'a vaqtincha mavjud emas",
  'gift.blockedText': "Biz bu sovg'ani tekshiryapmiz. Qo'llab-quvvatlashga yozing — aniqlashga yordam beramiz.",
  'gift.ownBlocked': "Sovg'a vaqtincha mavjud emas: biz uni tekshiryapmiz.",
  'gift.giveMore': "Yana sovg'a qilish",

  /* Экраны 10, 13, 14 — «Принять или отказаться» (БП-7, BE-51). Глагол отправителя — в настоящем времени: пол неизвестен. */
  'gift.decisionClosedTitle': "Sovg'a yuboruvchiga qaytdi",
  'gift.decisionClosedText': "Unga endi qaror qabul qilib bo'lmaydi: vaqt tugagan yoki siz boshqa qurilmada sovg'adan voz kechgansiz.",
  'decision.anonymous': 'Anonim yuboruvchi',
  'decision.sends': "sizga sovg'a yubormoqda",
  'decision.sentAt': '{date}, {time}',
  'decision.kind': "Sovg'a sertifikati",
  'decision.noExpiry': 'Amal qilish muddati cheklanmagan',
  'decision.where': 'Qayerda qabul qilinadi',
  'decision.acceptHint': "Sovg'ani qabul qiling — kassada to'lash uchun QR-kod olasiz.",
  'decision.deadline': "Agar {date}, {time} gacha qaror qilmasangiz, sovg'a yuboruvchiga qaytadi.",
  'decision.accept': "Sovg'ani qabul qilish",
  'decision.decline': "Sovg'adan voz kechish",
  'decision.declineConfirm': "Sovg'a yuboruvchiga qaytadi. Voz kechasizmi?",
  'decision.declineYes': 'Voz kechish',
  'decision.declineNo': "Sovg'ani qoldirish",
  'decision.offline': "Internet aloqasi yo'q. Tekshiring va yana bir bor bosing.",
  'decision.failed': "Bo'lmadi. Bir daqiqadan so'ng qayta urinib ko'ring.",
  'decision.declinedTitle': "Sovg'a yuboruvchiga qaytarildi",
  'decision.declinedText': "Yuboruvchiga xabar beramiz — sovg'a yana unda va uni boshqa kishiga sovg'a qilish mumkin.",
  'decision.toCatalog': 'Katalogga',
  'voucher.accepted': "Sovg'a qabul qilindi",

  'voucher.from': '— {name}',
  'voucher.fromOnly': "{name} dan sovg'a",
  'voucher.qrLabel': 'Kassa uchun vaucher QR-kodi',
  'voucher.copy': 'Nusxa olish',
  'voucher.usedTitle': 'Vaucher allaqachon ishlatilgan',
  'voucher.numberLabel': 'Vaucher raqami',
  'voucher.howTo': 'Qanday foydalanish kerak',
  'voucher.howStep1': "«Kassirga ko'rsatish» tugmasini bosing yoki vaucher raqamini ayting",
  'voucher.howStep2': 'Kassir kodni skanerlab, summani tasdiqlaydi',
  'voucher.howStep3': "Vaucher bitta xaridda to'liq ishlatiladi",
  'voucher.partnerNote': 'Hamkordan',
  'voucher.terms': 'Foydalanish shartlari',
  'voucher.where': 'Qayerda qabul qilinadi',
  'voucher.noLocations': "Hozir ochiq filiallar yo'q. Qo'llab-quvvatlashga yozing — vaucherni qayerda ishlatishni aytamiz.",
  'voucher.offline': "Internet yo'q. Vaucher telefon xotirasidan ko'rsatilgan — QR-kod amal qiladi.",
  'voucher.offlineLoading': "Internet yo'q. Aloqa tiklanishi bilan vaucher paydo bo'ladi.",
  'voucher.doneTitle': 'Vaucher ishlatildi',
  'voucher.undoText': "Agar xarid amalga oshmagan bo'lsa, kassirdan to'lovni bekor qilishni so'rang — vaucher yana amal qiladi. Keyinroq — faqat qo'llab-quvvatlash xizmati orqali.",
  'voucher.cancelledTitle': 'Ishlatish bekor qilindi',
  'voucher.cancelledText': "Vaucher yana amal qiladi. Xarid davom etsa, QR-kodni kassirga qayta ko'rsating.",

  /* Экраны 15–19: ваучер, QR для кассира, погашение и его отмена */
  'voucher.codeHint': "QR-kod o'qilmasa, kassir bu raqamni qo'lda kiritadi",
  'voucher.qrHint': "Kassir QR-kodni skanerlaydi yoki vaucher raqamini qo'lda kiritadi",
  'voucher.codeCopied': 'Kod nusxalandi',
  'voucher.nominal': 'Nominal',
  'voucher.showButton': "Kassirga ko'rsatish",
  'voucher.showButtonLabel': "QR-kodni kassirga ko'rsatish",
  'voucher.showAgain': "QR-kodni qayta ko'rsatish",
  'voucher.close': 'Yopish',
  'voucher.doneText': "{amount} so'mlik vaucher ishlatildi.",
  'voucher.time': 'Vaqt',
  'voucher.undoTitle': '{time} gacha bekor qilish mumkin',
  'voucher.done': 'Tayyor',
  'voucher.usedAt': '{date} da ishlatilgan',
  'qr.done': 'Tayyor',
  'qr.caption': "{brand} · {amount} so'm",
  'qr.waiting': 'Kassir skanerlashini kutyapmiz…',

  'location.closedToday': 'Bugun dam olish kuni',

  /* Экраны 11–12: «Где принимают», выбор навигатора */
  'location.open': 'Ochiq',
  'location.until': '{time} gacha',
  'location.closed': 'Yopiq',
  'location.opensAt': '{time} da ochiladi',
  'location.meters': '{value} m',
  'location.kilometers': '{value} km',
  'locations.search': "Manzil yoki tuman bo'yicha qidirish",
  'locations.points.one': '{count} ta nuqta',
  'locations.points.other': '{count} ta nuqta',
  'locations.countNearest': '{points} · eng yaqinlari yuqorida',
  'locations.found': 'Topildi: {count}',
  'locations.hint': "Navigatorda yo'nalish qurish uchun nuqtani bosing.",
  'locations.showNearest': "Eng yaqinlarini ko'rsatish",
  'locations.emptyTitle': "Hozircha nuqtalar yo'q",
  'locations.notFound': 'Hech narsa topilmadi',
  'locations.notFoundSub': 'Boshqa manzil yoki tumanni kiriting',
  'navigator.yandexNavi': 'Yandex Navigator',
  'navigator.yandexMaps': 'Yandex Xaritalar',
  'navigator.googleMaps': 'Google Maps',
  'navigator.2gis': '2GIS',
  'navigator.default': 'asosiy',
  'navigator.call': "Qo'ng'iroq qilish · {phone}",
  'navigator.copyAddress': 'Manzilni nusxalash',
  'navigator.addressCopied': 'Manzil nusxalandi',

  'notFound.title': 'Sahifa topilmadi',
  'notFound.text': "Havola eskirgan yoki sovg'a o'chirilgan.",

  'reopenApp.title': 'Ilovani qayta oching',
  'reopenApp.text': 'Ilova juda uzoq vaqt ochiq turdi. Uni yoping va qaytadan ishga tushiring.',
  'reopenApp.draftKept': "Qabul qiluvchi ismi va tabrik saqlanib qoladi — sovg'ani qayta rasmiylashtirganingizda ular o'z joyida bo'ladi.",
  'reopenApp.close': 'Ilovani yopish',

  'accountBlocked.title': 'Hisob bloklangan',
  'accountBlocked.text': "Ilova hozircha bu hisob uchun mavjud emas, ammo sotib olingan va sovg'a qilingan vaucherlaringiz amal qiladi. Quyidagi kodni qo'llab-quvvatlashga yuboring — ularni ko'rsatishga yordam beramiz.",

  'appError.title': 'Nimadir buzildi',
  'appError.text': 'Xatolik hisoboti bizga yuborildi. Ekranni yangilang — qoralama saqlandi.',
  'appError.reload': 'Ekranni yangilash',

  'netError.title': "Aloqa yo'q",
  'netError.text': "Internetni tekshirib qayta urinib ko'ring — ma'lumot avtomatik yuklanadi.",

  'settings.language': 'Til',
  'settings.theme': 'Mavzu',
  'settings.themeSystem': "Telegram'dagidek",
  'settings.themeLight': "Yorug'",
  'settings.themeDark': "Qorong'i",

  /* Итерация 4: онбординг, профиль, язык, оформление, поддержка. */
  'onboarding.giftTitle': "Esda qoladigan sovg'alar",
  'onboarding.giftLead': "Hamkorlar sertifikatlari — hammasi Telegram ichida, ilovalar va ro'yxatdan o'tishsiz.",
  'onboarding.giftPoint1': "Sovg'a chiroyli ochiladi — xuddi haqiqiy quti kabi",
  'onboarding.giftPoint2': "Do'konlar, kafelar va xizmatlar sertifikatlari",
  'onboarding.payTitle': "Bir necha soniyada to'lov",
  'onboarding.payLead': "Click va Payme provayderning himoyalangan oynasida — karta ma'lumotlari bizga kelmaydi.",
  'onboarding.payPoint1': 'UZCARD va Humo kartalari — Click va Payme orqali',
  'onboarding.payPoint2': 'Holatlari bilan xaridlar tarixi',
  'onboarding.sendTitle': "Sovg'a oldindan tayyor",
  'onboarding.sendLead': "To'lovdan so'ng «Sovg'ani yuborish» tugmasini bosing va chatni tanlang — sovg'a tabrik bilan birga ketadi.",
  'onboarding.sendPoint1': "Tabrik sovg'a ichida",
  'onboarding.sendPoint2': "Oluvchi kassada QR-kodni ko'rsatadi",
  'onboarding.next': 'Keyingi',
  'onboarding.start': 'Boshlash',
  'onboarding.skip': "O'tkazib yuborish",
  'onboarding.progress': '{total} dan {step}-qadam',

  'profile.title': 'Profil',
  'profile.statReceived': "Olingan sovg'alar",
  'profile.statGiven': "Hadya qilingan sovg'alar",
  'profile.language': 'Til',
  'profile.support': 'Yordam',

  'appearance.title': "Ko'rinish",
  'appearance.footer': "«Telegram'dagidek» — mavzu ilova bilan birga almashadi.",

  'language.title': 'Til',
  'language.footer': "Til barcha ekranlarga darhol qo'llanadi. Standart holatda Telegram profilidan olinadi. Bot ham sizga shu tilda yozadi.",
  'language.uz': "O'zbekcha",
  'language.ru': 'Ruscha',
  'language.en': 'Inglizcha',

  'support.topic': 'Murojaat mavzusi',
  'support.message': 'Xabar',
  'support.messageHint': "Nima bo'lganini yozing. Yordam javobi «Murojaatlarim»da paydo bo'ladi.",
  'support.messagePlaceholder': 'Masalan: kassir QR-kodni skanerlay olmadi',
  'support.send': 'Yuborish',
  'support.sendDisabled': "Bir-ikki so'z yozing",
  'support.sendOffline': "Aloqa yo'q — xabar yuborilmadi. Matn saqlandi, qayta urinib ko'ring.",
  'support.sendFailed': "Yuborib bo'lmadi. Yana urinib ko'ring.",
  'support.gift': "Sovg'a",
  'support.giftHint': "Sovg'ani murojaatga o'zimiz biriktiramiz — raqamni qidirish shart emas.",
  'support.myTickets': 'Murojaatlarim',
  'support.sent': '{number} murojaati yuborildi',

  'ticket.kindPayment': "To'lov bilan muammo",
  'ticket.kindVoucher': 'Vaucher qabul qilinmadi',
  'ticket.kindRefund': 'Pulni qaytarish',
  'ticket.kindGeneral': 'Boshqa savol',
  'ticket.statusOpen': 'Ochiq',
  'ticket.statusInProgress': 'Ishda',
  'ticket.statusWaiting': 'Javobingiz kutilmoqda',
  'ticket.statusResolved': 'Hal qilindi',
  'ticket.statusClosed': 'Yopilgan',
  'ticket.status': 'Holat',
  'ticket.reply': 'Javob',
  'ticket.replyPlaceholder': 'Javob yozing',
  'ticket.replyDisabled': 'Javob yozing',
  'ticket.replySent': 'Javob yuborildi',
  'ticket.closedHint': "Murojaat yopilgan. Savol qolgan bo'lsa — yangisini yarating.",
  'ticket.newTicket': 'Yangi murojaat',
  'ticket.notFoundTitle': 'Murojaat topilmadi',
  'ticket.notFoundText': "Havola eskirgan bo'lishi mumkin. Yangi murojaat yarating — yordam beramiz.",
  'ticket.emptyTitle': "Hozircha murojaatlar yo'q",
  'ticket.emptySub': "Murojaatlaringiz va yordam javoblari shu yerda paydo bo'ladi.",
  'ticket.authorYou': 'Siz',
  'ticket.authorSupport': 'Yordam',
  'profile.myGifts': "Sovg'alarim",
  'profile.history': 'Buyurtmalar tarixi',
  'myGifts.tabs': "Qaysi sovg'alarni ko'rsatish",
  'myGifts.received': 'Olinganlar',
  'myGifts.give': "Sovg'a qilish",
  'myGifts.receivedFooter': "Siz ochgan sovg'alar. Kod va QR — ichida, «Sovg'ani qabul qilish»dan keyin.",
  'myGifts.giveFooter': "To'langan sovg'alar yuborilishini kutmoqda: «Sovg'ani yuborish» tugmasini bosing va chatni tanlang. Yuborilgan, lekin hali ochilmagan sovg'ani qaytarib olish mumkin.",
  'myGifts.emptyReceivedTitle': "Hozircha sovg'a yo'q",
  'myGifts.emptyReceivedText': "Olingan sovg'alar qutini ochishingiz bilan shu yerda paydo bo'ladi.",
  'myGifts.emptyGiveTitle': "Yuboradigan sovg'a yo'q",
  'myGifts.emptyGiveText': 'Katalogdan sertifikat sotib oling — u shu yerda yuborilishini kutadi.',
  'giftList.title': '{brand} · {amount}',
  'giftList.from': '{name} dan',
  'giftList.fromAnonymous': 'anonim',
  'giftList.loadErrorTitle': "Sovg'alarni yuklab bo'lmadi",
  'giftStatus.ready': 'Yuborishga tayyor',
  'giftStatus.sent': 'Yuborilgan',
  'giftStatus.opened': 'Ochilgan, javob kutilmoqda',
  'giftStatus.accepted': 'Qabul qilingan',
  'giftStatus.redeemed': 'Ishlatilgan',
  'giftStatus.blocked': 'Tekshiruvda',
  'giftStatus.refunded': 'Pul qaytarilgan',
  'giftStatus.awaitingDecision': 'Qaroringiz kutilmoqda',
  'giftStatus.active': 'Amalda',
  'giftStatus.used': 'Ishlatilgan',
  'giftStatus.unavailable': 'Mavjud emas',
  'history.filters': "Sovg'alar holati",
  'history.all': 'Hammasi',
  'history.active': 'Faol',
  'history.redeemed': 'Ishlatilgan',
  'history.refunded': 'Qaytarilgan',
  'history.footer': "Siz sotib olgan barcha sovg'alar. Vaucher kodini faqat qabul qiluvchi ko'radi.",
  'history.emptyTitle': "Hozircha xarid yo'q",
  'history.emptyText': "Sotib olingan sertifikatlar shu yerda ko'rinadi.",
  'history.emptyFilterTitle': "Hozircha bo'sh",
  'history.emptyFilterText': "Bunday holatdagi sovg'alar yo'q.",
  'paySuccess.later': "Keyinroq yuboraman — sovg'a «Sovg'alarim»da qoladi",

  'ownGift.status': 'Holat',
  'ownGift.number': "Sovg'a raqami",
  'ownGift.orderNumber': 'Buyurtma raqami',
  'ownGift.timeline': "Sovg'a tarixi",
  'ownGift.paidAt': "To'langan",
  'ownGift.sentAt': 'Chatga yuborilgan',
  'ownGift.openedAt': 'Ochilgan',
  'ownGift.claimedAt': 'Qabul qilingan',
  'ownGift.redeemedAt': 'Ishlatilgan',
  'ownGift.refundedAt': 'Pul qaytarildi',
  'ownGift.dateTime': '{date}, {time}',
  'ownGift.greeting': 'Tabrik',
  'ownGift.anonymous': "Imzosiz — sovg'a anonim",
  'ownGift.stateReady': "Sovg'a hali yuborilmagan. «Sovg'ani yuborish» tugmasini bosing, chatni, so'ng ro'yxatdan shu sovg'ani tanlang.",
  'ownGift.stateSent': "Sovg'a chatda. Uni «Sovg'ani ochish» tugmasini birinchi bosgan kishi oladi.",
  'ownGift.stateOpened': "Qabul qiluvchi qutini ochdi va sovg'ani qabul qilish-qilmaslikni hal qilmoqda.",
  'ownGift.stateAccepted': "Qabul qiluvchi sovg'ani qabul qildi. Vaucher kodini faqat u ko'radi.",
  'ownGift.stateRedeemed': "Sovg'a {place} da ishlatildi.",
  'ownGift.stateRedeemedNoPlace': "Sovg'a ishlatildi.",
  'ownGift.stateRefunded': "Sovg'a uchun pul qaytarildi — u 1–7 kun ichida kartaga tushadi.",
  'ownGift.decisionTitle': 'Javob — {date}, {time} gacha',
  'ownGift.decisionText': "Javob bermasa, sovg'a sizga qaytadi. Ochilgan sovg'ani qaytarib olib bo'lmaydi.",
  'ownGift.revoke': "Sovg'ani qaytarib olish",
  'ownGift.revokeFooter': "Chatdagi karta ochilmay qoladi, sovg'a esa sizga qaytadi — uni qayta yuborish mumkin bo'ladi.",
  'ownGift.revokeConfirm': "Sovg'ani qaytarib olasizmi? Chatdagi karta ochilmay qoladi.",
  'ownGift.revokeConfirmButton': 'Qaytarib olish',
  'ownGift.revoked': "Sovg'a qaytarib olindi — u yana sizda",
  'ownGift.revokeStale': "Endi qaytarib olib bo'lmaydi: sovg'a ochilgan yoki u endi chatda emas",
  'ownGift.refund': 'Pulni qaytarish',
  'ownGift.refundFooter': "Pul to'lov qilgan kartangizga 1–7 kun ichida qaytadi. Shundan keyin sovg'ani yuborib bo'lmaydi.",
  'ownGift.refundConfirm': "{amount} so'm qaytarilsinmi? Pul to'lov qilgan kartangizga 1–7 kun ichida tushadi. Bu sovg'ani endi yuborib bo'lmaydi.",
  'ownGift.refundConfirmButton': 'Pulni qaytarish',
  'ownGift.refunded': 'Qaytarish rasmiylashtirildi — pul 1–7 kun ichida kartaga tushadi',
  'ownGift.refundStale': "Pulni tugma orqali qaytarib bo'lmaydi: sovg'a chatga yuborilgan yoki allaqachon qaytarilgan",
  'ownGift.refundAlready': "Bu sovg'a uchun pul allaqachon qaytarilgan",
  'ownGift.refundRejected': "To'lov tizimi qaytarishni amalga oshirmadi. Sovg'a sizda qoldi — keyinroq urinib ko'ring yoki yordamga yozing.",
  'ownGift.actionOffline': "Aloqa yo'q. Internetni tekshiring va qayta urinib ko'ring.",
  'ownGift.actionFailed': "Bo'lmadi. Qayta urinib ko'ring.",
  'ownGift.supportFooter': "Chatda yoki qabul qiluvchida turgan sovg'a uchun pulni yordam xizmati orqali qaytarish mumkin.",
  'giftStatus.returned': 'Sizga qaytdi',
  'ownGift.returnedAt': 'Sizga qaytgan',
  'ownGift.stateDeclined': "Qabul qiluvchi sovg'adan voz kechdi, u yana sizda. Uni boshqa kishiga yuboring yoki pulni qaytaring.",
  'ownGift.stateTimedOut': "Sovg'a 7 kun ichida qabul qilinmadi va sizga qaytdi. Uni qayta yuboring yoki pulni qaytaring.",
  'ownGift.stateRevoked': "Siz sovg'ani qaytarib oldingiz — u yana sizda. Uni qayta yuboring yoki pulni qaytaring.",
  'ownGift.sendAgain': 'Qayta yuborish',
}
